import type { AppState } from '@protector/entities/__legacy__/redux.types';
import { createSelector } from 'reselect';

export const verifyNemadigitalConfigAvailability = createSelector(
  (state: AppState) => state.uiState.auth.permissionFlags?.nemaDigital?.value,
  permissionFlagNemaDigital => !!permissionFlagNemaDigital
);
